import React,  { Component } from 'react'
import Cglobal from '../cglobal';
import OverWindow from './OverWindow';


class PanelBorder extends Component 
{

    static defaultProps={
        headerText:"Default Header Text",
        clickOnCancel:(()=>alert("PanelBorder - Please, define cancel action!")),
        container: false,
        minWidth:"200px",
        maxWidth:"100vw",
        icon:"",
        disableClose:false,
        itemToSave:null,//This is the item which will be saved, for example searchItem from SearchLeadPanel
        saveType:"",//This is the type of the item, for example: "LeadSearchParams"
        onSavedItemChanged:(item)=>{},//this function is called when the saved item is loaded from tha backend. Use it in the parent component to change your oroginal item.
        saveWindowText:"Save Data",
        openWindowText:"Open Data",
        exportFunction:null,
        minHeight:'500px'
    };


    constructor(props) 
    {
        super(props);
        this.state = {
            loading:true
        };
    }

    componentDidMount() 
    {
        Cglobal.contentScrollToTheTop();
        setTimeout(()=>this.setState({loading:false}),1000);
    }
    
    componentDidUpdate(prevProps)
    {
        if(this.props.headerText!==prevProps.headerText)
        {
            Cglobal.contentScrollToTheTop();
            this.setState({loading:true});
            setTimeout(()=>this.setState({loading:false}),1000);
        }
    }

    render()
    {
        return (
            <OverWindow
                title={this.props.headerText}
                clickOnCancel={this.props.clickOnCancel}
                icon="fa-solid fa-home"
                minHeight={this.props.minHeight}
            >
                {this.props.children}
            </OverWindow>
        );
    }
}


export default PanelBorder;
